import * as z from 'zod';
import '../../types/actor/actor.mjs';
import '../../types/address/address.mjs';
import '../../types/credit-report/company-credit-report.mjs';
import '../../types/credit-report/individual-credit-report.mjs';
import '../../types/currency/currency.mjs';
import '../../types/entityRelation/entity-relation.mjs';
import '../../types/financial-formula/adjustable-value.mjs';
import '../../types/financial-formula/adjustable-values-update.mjs';
import '../../types/financial-formula/adjustment.mjs';
import '../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../types/is-encrypted.mjs';
import '../../types/naics-codes/naics-codes.mjs';
import { isoDateSchema } from '../../types/opaque.mjs';
import '../../types/surety/account/bonding-line.mjs';
import '../../types/surety/account/surety-account.types.mjs';
import '../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../types/surety/bond/surety-bond.types.mjs';
import '../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../types/surety/contract/contract-extraction-output.mjs';
import '../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../types/surety/quote/surety-quote.types.mjs';
import '../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../types/user/user.types.mjs';
import { currencySchema } from '../../types/utils.mjs';
import { Get as Get$1 } from '../admin/financial-period/admin-financial-period.dto.mjs';
import { Get } from '../surety/financial-period/financial-extraction.dto.mjs';

var BlocSize;
(function (BlocSize) {
    (function (Update) {
        (function (Request) {
            Request.schema = z.object({
                fyeDate: isoDateSchema,
                blocSize: currencySchema,
            });
        })(Update.Request || (Update.Request = {}));
    })(BlocSize.Update || (BlocSize.Update = {}));
})(BlocSize || (BlocSize = {}));
var Profitability;
(function (Profitability) {
    (function (Upsert) {
        (function (Request) {
            Request.schema = z
                .object({
                profitableLastFye: z.boolean().optional(),
                profitableYtd: z.boolean().optional(),
            })
                .refine((v) => v.profitableLastFye !== undefined || v.profitableYtd !== undefined, {
                message: "At least one profitability value is required.",
            });
        })(Upsert.Request || (Upsert.Request = {}));
        (function (Response) {
            Response.schema = z.object({
                lastFye: Get.Response.schema.optional(),
                ytd: Get.Response.schema.optional(),
            });
        })(Upsert.Response || (Upsert.Response = {}));
    })(Profitability.Upsert || (Profitability.Upsert = {}));
    (function (UpsertOnPeriod) {
        (function (Request) {
            Request.schema = z
                .object({
                profitableLastFye: z.boolean().optional(),
                profitableYtd: z.boolean().optional(),
            })
                .refine((v) => v.profitableLastFye !== undefined || v.profitableYtd !== undefined, {
                message: "At least one profitability value is required.",
            });
        })(UpsertOnPeriod.Request || (UpsertOnPeriod.Request = {}));
        (function (Response) {
            Response.schema = z.object({
                lastFye: Get$1.Response.schema.optional(),
                ytd: Get$1.Response.schema.optional(),
            });
        })(UpsertOnPeriod.Response || (UpsertOnPeriod.Response = {}));
    })(Profitability.UpsertOnPeriod || (Profitability.UpsertOnPeriod = {}));
})(Profitability || (Profitability = {}));

export { BlocSize, Profitability };
